// extracted by mini-css-extract-plugin
module.exports = {"SearchInput":"SearchInput_SearchInput__2oAw1","Paragraph":"SearchInput_Paragraph__3rsyV"};